module.exports = __webpack_public_path__ + "static/media/logo-one.0b107480.svg";